import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { createEnhancedLocationFromStringLocation } from 'owa-location-persona';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { updateLocations } from 'owa-calendar-compose-form-actions';

export const getLocation = (): string => {
    const event = getComposeStore().event;
    if (!event.Locations || event.Locations.length <= 0) {
        return null;
    }

    if (event.Locations.length === 1) {
        return event.Locations[0].DisplayName;
    }

    const displayNames: string[] = event.Locations.map(location => location.DisplayName);
    return displayNames.join('; ');
};

export const setLocation = (locationString: string): void => {
    // trim and filter empty locations and duplicates
    const locations: string[] = !isNullOrWhiteSpace(locationString)
        ? locationString
              .split(';')
              .map(location => location.trim())
              .filter((location, index, array) => location && array.indexOf(location) == index)
        : [];

    let newLocations: EnhancedLocation[] = [];
    locations.forEach(location => {
        newLocations.push(createEnhancedLocationFromStringLocation(location));
    });

    updateLocations(newLocations);
};
